import * as mutationType from "../mutation_types";
import moment from "moment";
import { formatPaginationParams } from "../../helpers/api";

const state = {
  users: [],
  user_teams: [],
  edit_user: {},
  search_users: [],
  managers: [],
  activities: [],
  managed_users: [],
  reviewers: []
};

const getters = {
  users: state => state.users,
  user_teams: state => state.user_teams,
  edit_user: state => state.edit_user,
  is_manager: state => {
    return state.edit_user.isManager || false;
  },
  search_users: state => state.search_users,
  managers: state => state.managers,
  activities: state => state.activities,
  managed_users: state => state.managed_users,
  reviewers: state => state.reviewers
};

const actions = {
  getUsers({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/users")
        .then(res => {
          commit(mutationType.SET_USERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  searchUsers({ commit }, search) {
    return new Promise((resolve, reject) => {
      let filter = {};
      if (search.directManagerId) {
        filter.relatedId = search.directManagerId;
      }
      if (search.allowAll) {
        filter.allowAll = search.allowAll;
      }
      if (search.onlyManagers) {
        filter.onlyManagers = search.onlyManagers;
      }
      this._vm.$http
        .get("/api/users/search", {
          params: formatPaginationParams(filter)
        })
        .then(res => {
          commit(mutationType.SET_SEARCH_USERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  clearSearchUsers({ commit }) {
    return new Promise(resolve => {
      commit(mutationType.SET_SEARCH_USERS, []);
      resolve();
    });
  },
  clearUser({ commit }) {
    return new Promise(resolve => {
      commit(mutationType.SET_EDIT_USER, {});
      resolve();
    });
  },
  getUser({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/users/" + id)
        .then(res => {
          commit(mutationType.SET_EDIT_USER, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  addUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/users", user)
        .then(res => {
          user.id = res.data;
          commit(mutationType.SET_USER, user);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  bulkAddUsers({}, emails) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          "/api/users/bulk",
          emails.map(e => ({ email: e }))
        )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  saveRegistration({}, domains) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/users/registration", domains)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  deleteRegistration({}) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/users/registration")
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/users/" + user.id, user)
        .then(() => {
          commit(mutationType.SET_USER, user);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateUserRole({ commit }, user) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/users/" + user.id, user)
        .then(() => {
          commit(mutationType.SET_EDIT_USER_ROLE, user);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteUser({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/users/" + id)
        .then(() => {
          commit(mutationType.DELETE_USER, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getManagers({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/managers")
        .then(res => {
          commit(mutationType.SET_MANAGERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getManagedUsers({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/managers/" + id + "/members")
        .then(res => {
          commit(mutationType.SET_MANAGED_USERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getActivities({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/users/" + id + "/activities")
        .then(res => {
          commit(mutationType.SET_ACTIVITIES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getManagerActivities({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/managers/" + id + "/activities")
        .then(res => {
          commit(mutationType.SET_MANAGER_ACTIVITIES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  importUsers({}, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("file", file);
      this._vm.$http
        .post("/api/users/import", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReviewers({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/users/" + id + "/reviewers")
        .then(res => {
          commit(mutationType.SET_REVIEWERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReviewers({ commit }, update) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/users/" + update.userId + "/reviewers", update.reviewers)
        .then(() => {
          commit(mutationType.SET_REVIEWERS, update.reviewers);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  getExport({}) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/users/export")
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `user_export_${moment().format("MM_DD_YYYY_HH_mm")}.csv`
          );
          document.body.appendChild(link);
          link.click();
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_USERS](state, list) {
    state.users = list;
  },
  [mutationType.SET_EDIT_USER](state, user) {
    state.edit_user = user;
  },
  [mutationType.SET_EDIT_USER_ROLE](state, user) {
    state.edit_user.systemRoleName = user.systemRoleName;
    state.edit_user.systemRoleId = user.systemRoleId;
  },
  [mutationType.SET_USER](state, user) {
    let index = state.users.findIndex(cv => cv.id == user.id);
    if (index >= 0) {
      state.users[index] = user;
    }
  },
  [mutationType.SET_SEARCH_USERS](state, list) {
    state.search_users = list;
  },
  [mutationType.DELETE_USER](state, id) {
    let index = state.users.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.users.splice(index, 1);
    }
  },
  [mutationType.SET_USER_TEAMS](state, teams) {
    state.edit_user.teams = teams;
  },
  [mutationType.SET_MANAGERS](state, list) {
    state.managers = list;
  },
  [mutationType.SET_MANAGED_USERS](state, list) {
    state.managed_users = list;
  },
  [mutationType.SET_ACTIVITIES](state, list) {
    state.activities = list;
  },
  [mutationType.SET_MANAGER_ACTIVITIES](state, list) {
    state.activities = list;
  },
  [mutationType.SET_REVIEWERS](state, list) {
    state.reviewers = list.map(x => Object.assign({ isActive: true }, x));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
